module.exports = __webpack_public_path__ + "img/gp_promotion_female_3.dea2ea08.png";